import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import * as selectors from '../../dashboard/state';

export const TraineeManagementGuard: CanActivateFn = () => {
  const store = inject(Store);

  return store.select(selectors.getTraineeLoaded).pipe(
    filter((loaded: boolean) => loaded), // wait until the API call has returned
    switchMap(() => store.select(selectors.getTraineeManagementAccess)),
    take(1),
  ) as Observable<boolean>;
};
